module.exports = {
	"_args": [
		[
			"elliptic@6.5.4",
			"D:\\期货官网H5\\cesfweb\\MobileWeb"
		]
	],
	"_development": true,
	"_from": "elliptic@6.5.4",
	"_id": "elliptic@6.5.4",
	"_inBundle": false,
	"_integrity": "sha512-iLhC6ULemrljPZb+QutR5TQGB+pdW6KGD5RSegS+8sorOZT+rdQFbsQFJgvN3eRqNALqJer4oQ16YvJHlU8hzQ==",
	"_location": "/elliptic",
	"_phantomChildren": {},
	"_requested": {
		"type": "version",
		"registry": true,
		"raw": "elliptic@6.5.4",
		"name": "elliptic",
		"escapedName": "elliptic",
		"rawSpec": "6.5.4",
		"saveSpec": null,
		"fetchSpec": "6.5.4"
	},
	"_requiredBy": [
		"/browserify-sign",
		"/create-ecdh"
	],
	"_resolved": "http://192.168.29.50:8081/repository/npm-proxy-npmjs/elliptic/-/elliptic-6.5.4.tgz",
	"_spec": "6.5.4",
	"_where": "D:\\期货官网H5\\cesfweb\\MobileWeb",
	"author": {
		"name": "Fedor Indutny",
		"email": "fedor@indutny.com"
	},
	"bugs": {
		"url": "https://github.com/indutny/elliptic/issues"
	},
	"dependencies": {
		"bn.js": "^4.11.9",
		"brorand": "^1.1.0",
		"hash.js": "^1.0.0",
		"hmac-drbg": "^1.0.1",
		"inherits": "^2.0.4",
		"minimalistic-assert": "^1.0.1",
		"minimalistic-crypto-utils": "^1.0.1"
	},
	"description": "EC cryptography",
	"devDependencies": {
		"brfs": "^2.0.2",
		"coveralls": "^3.1.0",
		"eslint": "^7.6.0",
		"grunt": "^1.2.1",
		"grunt-browserify": "^5.3.0",
		"grunt-cli": "^1.3.2",
		"grunt-contrib-connect": "^3.0.0",
		"grunt-contrib-copy": "^1.0.0",
		"grunt-contrib-uglify": "^5.0.0",
		"grunt-mocha-istanbul": "^5.0.2",
		"grunt-saucelabs": "^9.0.1",
		"istanbul": "^0.4.5",
		"mocha": "^8.0.1"
	},
	"files": [
		"lib"
	],
	"homepage": "https://github.com/indutny/elliptic",
	"keywords": [
		"EC",
		"Elliptic",
		"curve",
		"Cryptography"
	],
	"license": "MIT",
	"main": "lib/elliptic.js",
	"name": "elliptic",
	"repository": {
		"type": "git",
		"url": "git+ssh://git@github.com/indutny/elliptic.git"
	},
	"scripts": {
		"lint": "eslint lib test",
		"lint:fix": "npm run lint -- --fix",
		"test": "npm run lint && npm run unit",
		"unit": "istanbul test _mocha --reporter=spec test/index.js",
		"version": "grunt dist && git add dist/"
	},
	"version": "6.5.4"
};


//////////////////
// WEBPACK FOOTER
// ./~/elliptic/package.json
// module id = 509
// module chunks = 2